import { createReducer } from 'helpers/ReducerUtil'
import { combineReducers } from 'redux'
import * as R from 'ramda'

import {
  ROW_OPTIONS,
  UPDATE_PAGE_SIZE,
  UPDATE_COUNT_SIZE,
  UPDATE_CURRENT_PAGE,
  UPDATE_PARTNER_SITE_LIST,
  UPDATE_SEARCH_VALUE,
  UPDATE_EDIT_VALUE,
  CLEAR_EDIT_VALUE,
  CLEAR_PARTNER_SITE_LIST,
} from './constants'

const unionAndSort = R.compose(
  R.sort((a, b) => a - b),
  R.union
)

const updatePageSize = (prev, { size }) => size
const updateCountSize = (prev, { count }) => count
const updateCurrentPage = (prev, { page }) => page
const updatePartnerSiteList = (prev, { partner_sites }) => unionAndSort(prev, partner_sites)
const updateSearchValue = (prev, { value }) => value
const updateEditValue = (prev, { value }) => value

const pageSizeSliceReducer = createReducer(ROW_OPTIONS[10], {
  [UPDATE_PAGE_SIZE]: updatePageSize
})

const countSizeSliceReducer = createReducer(0, {
  [UPDATE_COUNT_SIZE]: updateCountSize
})

const currentPageSliceReducer = createReducer(1, {
  [UPDATE_CURRENT_PAGE]: updateCurrentPage
})

const partnerSiteListReducer = createReducer([], {
  [CLEAR_PARTNER_SITE_LIST]: () => [],
  [UPDATE_PARTNER_SITE_LIST]: updatePartnerSiteList
})

const searchValueSliceReducer = createReducer('', {
  [UPDATE_SEARCH_VALUE]: updateSearchValue
})

const editSliceReducer = createReducer(false, {
  [CLEAR_EDIT_VALUE]: () => false,
  [UPDATE_EDIT_VALUE]: updateEditValue
})

export default combineReducers({
  count: countSizeSliceReducer,
  currentPage: currentPageSliceReducer,
  pageSize: pageSizeSliceReducer,
  partnerSites: partnerSiteListReducer,
  search: searchValueSliceReducer,
  edit: editSliceReducer,
})
